export const ROLES = {
    ADMIN: 'admin',
  STAFF: 'staff'
};

